var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pageContent"}},[(_vm.routeName !== 'matchDetail')?_c('TopBanner',{attrs:{"bg-img":_vm.bgImg,"main-title":_vm.mainTitle,"sub-title":_vm.subTitle}}):_vm._e(),_c('router-view',{staticClass:"contents"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }